"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeDocumentListWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var AnnualHomeDocumentListModal_1 = require("./AnnualHomeDocumentListModal");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var AnnualHomeDocumentListWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeDocumentListWidget, _super);
    function AnnualHomeDocumentListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    AnnualHomeDocumentListWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (services_1.resourcesHelper.THEME !== "Britannia") {
            this.customerPortalService
                .getOptionalExtrasInformation(this.props.engine.getInteraction().agreementNumber)
                .subscribe(function (optionalExtraChanges) {
                _this.setState({
                    addedHEDate: (0, commonFunctions_1.latestCoverChangeDate)(optionalExtraChanges, services_1.OptionalExtras.HOME_EMERGENCY),
                    addedHLEDate: (0, commonFunctions_1.latestCoverChangeDate)(optionalExtraChanges, services_1.OptionalExtras.HOME_LEGAL_EXPENSES)
                });
            });
        }
    };
    AnnualHomeDocumentListWidget.prototype.render = function () {
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)("div", { id: this.props.question.name, className: "documents-widget documents-output-widget ".concat(this.getSetting("cssClass", "")), children: [this.props.question.label ? ((0, jsx_runtime_1.jsx)("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18", children: this.props.question.label })) : "", this.getSetting("helpText") ? ((0, jsx_runtime_1.jsx)("p", { children: this.getSetting("helpText", "") })) : "", (0, jsx_runtime_1.jsx)(AnnualHomeDocumentListModal_1.AnnualHomeDocumentListModal, { policyDate: this.getPolicyStartDate(this.props.interaction), coverTier: this.props.interaction.coverTier, withTitle: false, addedHEDate: this.state.addedHEDate || new Date((_a = this.props.interaction.headerInfo) === null || _a === void 0 ? void 0 : _a.startDate), addedHLEDate: this.state.addedHLEDate || new Date((_b = this.props.interaction.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate), annualHomeFixedAddons: this.props.interaction.annualHomeFixedAddons })] }));
    };
    AnnualHomeDocumentListWidget.prototype.getPolicyStartDate = function (interaction) {
        var _a, _b, _c;
        return ((_a = interaction.factors) === null || _a === void 0 ? void 0 : _a.renewalQuoteDate)
            ? new Date((_b = interaction.factors) === null || _b === void 0 ? void 0 : _b.renewalQuoteDate) : new Date((_c = interaction.factors) === null || _c === void 0 ? void 0 : _c.originalQuoteDate);
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualHomeDocumentListWidget.prototype, "customerPortalService", void 0);
    return AnnualHomeDocumentListWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeDocumentListWidget = AnnualHomeDocumentListWidget;
//# sourceMappingURL=AnnualHomeDocumentListWidget.js.map